export type SsoProviderId = 'google' | 'microsoft' | 'cikisi';

export interface SsoProvider {
  id: SsoProviderId;
  label: string;
  path: string;
}

export const SSO_PROVIDERS: SsoProvider[] = [
  { id: 'google', label: 'Google', path: 'auth/google_oauth2' },
  { id: 'microsoft', label: 'Microsoft', path: 'auth/microsoft_graph' },
  { id: 'cikisi', label: 'Cikisi', path: 'auth/cikisi' },
];
